import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import { range } from 'es-toolkit';
import SmallLogo from '@/assets/svgs/small_logo.svg';
type Attendance = {
  date: number;
  checked: boolean;
};
interface DailyCheckStampCardProps {
  attendanceList?: Attendance[];
  isLoading: boolean;
}
export const DailyCheckStampCard = t0 => {
  const $ = _c(6);
  const {
    attendanceList,
    isLoading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = dayjs().date();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const today = t1;
  let t2;
  if ($[1] !== attendanceList || $[2] !== isLoading) {
    t2 = isLoading ? range(30).map(_temp) : attendanceList?.map(attendance => <Stamp key={attendance.date} checked={attendance.checked} date={attendance.date} isPast={attendance.date < today} />);
    $[1] = attendanceList;
    $[2] = isLoading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section className="rounded-small bg-Gray-white px-30 py-20"><ul className="grid grid-cols-[repeat(auto-fill,minmax(50px,1fr))] gap-x-18 gap-y-16">{t2}</ul></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const Stamp = t0 => {
  const $ = _c(6);
  const {
    checked,
    date,
    isPast
  } = t0;
  if (checked) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <li className="flex justify-center"><div className="flex size-53 items-center justify-center rounded-pill bg-B-500"><SmallLogo className="size-30 text-Gray-white" /></div></li>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== isPast) {
    t1 = cn("flex size-53 items-center justify-center rounded-pill border border-dashed border-Gray-300 font-600 text-Gray-400 typo-caption1", {
      "line-through": isPast
    });
    $[1] = isPast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== date || $[4] !== t1) {
    t2 = <li className="flex justify-center"><div className={t1}>{date}일</div></li>;
    $[3] = date;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(index) {
  return <Skeleton key={index} className="size-53 rounded-pill" />;
}